// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, takeEvery } from 'redux-saga/effects';
import ShopByLookStylitics from '@tcp/core/src/services/abstractors/shopByLookStylitics';

import { FETCH_SHOP_BY_LOOK_STYLITICS_REQUEST } from './ShopByLookStylitics.constants';
import {
  fetchShopByLookStyliticsSuccess,
  fetchShopByLookStyliticsFailure,
} from './ShopByLookStylitics.actions';

export function* fetchShopByLookStyliticsData({ payload }) {
  const { tagName, count, uniqueKey, isRedirectToPDP } = payload;

  try {
    const data = yield call(ShopByLookStylitics.getData, {
      count,
      tags: tagName,
      isRedirectToPDP,
      uniqueKey,
    });
    yield put(fetchShopByLookStyliticsSuccess(uniqueKey, data));
  } catch (error) {
    yield put(fetchShopByLookStyliticsFailure(uniqueKey, error.message));
  }
}

function* ShopByLookStyliticsSaga() {
  yield takeEvery(FETCH_SHOP_BY_LOOK_STYLITICS_REQUEST, fetchShopByLookStyliticsData);
}

export default ShopByLookStyliticsSaga;
